import {SelectFilterProvider} from '@github-ui/filter-core/providers'
import {ClockIcon} from '@primer/octicons-react'
import {singleValueFilterTypes} from '@github-ui/repos-rules-types/shared-filter-types'
import {DEFAULT_FILTER_PRIORITY} from '@github-ui/filter-core'

export class TimePeriodFilterProvider extends SelectFilterProvider {
  constructor() {
    super(
      {
        displayName: 'Time period',
        key: 'time-period',
        priority: DEFAULT_FILTER_PRIORITY,
        icon: ClockIcon,
        description: 'Specify the time period',
      },
      [
        {value: 'hour', displayName: 'Last hour', priority: 1},
        {value: 'day', displayName: 'Last 24 hours', priority: 2},
        {value: 'week', displayName: 'Last week', priority: 3},
        {value: 'month', displayName: 'Last month', priority: 4},
      ],
      {
        filterTypes: singleValueFilterTypes,
      },
    )
  }
}
